import { TimeStampAttributes } from '../../General/domain/general';
import { Institution } from '../../Institution/domain/institution';
import { Pronouns, Title } from '../../Person/domain/person';
import { Project } from '../../Project';
import { UploadType, UploadedMedia } from '../../Upload/domain/upload';

enum RoleInProject {
    None = 'none',
    Creator = 'creator',
    Participant = 'participant',
    Responsible = 'responsible',
    Admin = 'admin'
}

type RoleAndAdminState = {
    role: RoleInProject;
    isAdmin: boolean;
};

type ProfilePicture = UploadedMedia<UploadType.Image>;

interface User extends TimeStampAttributes {
    id: string;
    email: string;
    password: string;
    firstname: string;
    lastname: string;
    phone?: string;
    jobTitle?: string;
    title?: Title;
    pronouns?: Pronouns;
    motivation?: string;
    profilePicture?: ProfilePicture;
    institution?: Institution;
    isAdmin: boolean;
    isConfirmed: boolean;
    hasApproval: boolean;
    favouriteCompanies: Institution[];
    favouriteProjects: Project[];
}

type Author = Pick<User, 'id' | 'profilePicture' | 'jobTitle' | 'institution' | 'pronouns' | 'firstname' | 'lastname'> & {
    name: string;
};

/**
 * Fallback author used when the actual author cannot be found
 */
export const FALLBACK_AUTHOR: Readonly<Author> = {
    name: 'UnknownUser',
    id: 'unknown_user',
    firstname: 'Unknown',
    lastname: 'User',
    profilePicture: undefined,
    jobTitle: undefined,
    institution: undefined,
    pronouns: undefined
};

type FetchUsersInternalResponse = {
    users: User[];
    error?: Error;
};

export type { RoleAndAdminState, User, Author, FetchUsersInternalResponse, ProfilePicture };
export { RoleInProject };
